export default "__VITE_ASSET__DVuY1X9W__"